import { Component } from '@angular/core';
import { ButtonComponent, LinkComponent } from '@verticalbridge/ui-components';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [ButtonComponent, LinkComponent],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  currentYear = new Date().getFullYear();

  externalLinks = {
    aboutUs: 'https://www.verticalbridge.com/about',
    careers: 'https://www.verticalbridge.com/careers',
    leasingManagers: 'https://www.verticalbridge.com/leasing-managers',
    newsroom: 'https://www.verticalbridge.com/news/newsroom',
    contactUs: 'https://www.verticalbridge.com/contact',
    linkedin: 'https://www.linkedin.com/company/vertical-bridge',
    termsOfUse: 'https://www.verticalbridge.com/terms-of-use',
    privacyPolicy: 'https://www.verticalbridge.com/privacy-policy',
    accessibility: 'https://www.verticalbridge.com/accessibility',
  };

  companyInfo = {
    name: 'Vertical Bridge REIT, LLC',
    address1: '22 West Atlantic Avenue, Suite 310',
    address2: 'Delray Beach, FL 33444',
    phone: '(561) 948-6367',
    phoneHref: 'tel:+15619486367',
  };
}
